import ConfigCmsApi from "../configs/ConfigCmsApi";
import Cookies from "js-cookie";

// "Employees" — the old admin's /admins/index. The users service owns employees now (it already
// held the login, the password and the status; the rows still live in the monolith's `admins`
// table), but its admin routes are reachable from inside the cluster only, so the CMS goes
// through cms-api. The photo is uploaded to S3 by cms-api, which hands users the ready URL.
// every {id} below is users.id — the list's `id`; `legacy_id` (admins.id) only opens the old admin
const alias = "/employees";

const headers = () => ({ Authorization: Cookies.get("adminToken") });

const getList = ({ page = 1, perPage = 20, fullName = "", email = "", phone = "", departmentId = "" } = {}) =>
  ConfigCmsApi.get(alias, {
    params: {
      page,
      per_page: perPage,
      full_name: fullName,
      email,
      phone,
      department_id: departmentId,
    },
    headers: headers(),
  });

// the old admin's "Отдел" dropdown — `admins_groups`
const getDepartments = () => ConfigCmsApi.get(`${alias}/departments`, { headers: headers() });

// `avatar` is the square JPEG built by pages/Employees/avatarImage.js
const uploadAvatar = (userId, avatar, onUploadProgress) => {
  const formData = new FormData();
  formData.append("avatar", avatar, `employee-${userId}.jpeg`);

  return ConfigCmsApi.post(`${alias}/${userId}/avatar`, formData, { headers: headers(), onUploadProgress });
};

const removeAvatar = (userId) => ConfigCmsApi.delete(`${alias}/${userId}/avatar`, { headers: headers() });

// the password the login checks (users); only the admin department or a supervisor may set it
const setPassword = (userId, password) =>
  ConfigCmsApi.put(`${alias}/${userId}/password`, { password }, { headers: headers() });

// the edit form: {"employee": {"id": users.id, "admins": {...}, "user": {...}}}
const getProfile = (userId) => ConfigCmsApi.get(`${alias}/${userId}`, { headers: headers() });

// {"admins": {...}, "user": {...}}, both partial — only what the editor changed
const updateProfile = (userId, body) => ConfigCmsApi.patch(`${alias}/${userId}`, body, { headers: headers() });

// {"admins": {...}, "user": {...}, "password": "..."}
const create = (body) => ConfigCmsApi.post(alias, body, { headers: headers() });

// departments, manager groups, teams
const getDictionaries = () => ConfigCmsApi.get(`${alias}/dictionaries`, { headers: headers() });

const getPermissions = () => ConfigCmsApi.get(`${alias}/permissions`, { headers: headers() }).then(response => {
  if (typeof response.data?.can_manage_employees !== 'boolean') throw new Error('Employee permission unavailable');
  return response.data.can_manage_employees;
});

export default {
  getPermissions,
  getProfile,
  updateProfile,
  create,
  getDictionaries,
  getList,
  getDepartments,
  uploadAvatar,
  removeAvatar,
  setPassword,
};
